import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ConfigProvider } from './contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { setupAxiosAuth } from './setupAxiosAuth';

setupAxiosAuth();

const isDecisionPortal = process.env.REACT_APP_DECISION_PORTAL === '1';

const root = ReactDOM.createRoot(document.getElementById('root'));
const app = isDecisionPortal ? <App /> : (
  <ConfigProvider>
    <App />
  </ConfigProvider>
);

root.render(
  <React.StrictMode>
    {app}
  </React.StrictMode>
);

reportWebVitals();

if (!isDecisionPortal) {
  // PWA：自动更新并刷新到最新版本
  serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    try {
      if (registration?.waiting) {
        // 标记：本次 controllerchange 属于“更新接管”，需要刷新
        try {
          sessionStorage.setItem('sw_update_pending_reload', '1');
        } catch (e) {
          // ignore
        }
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    } catch (e) {
      // ignore
    }
  },
  });
}

// 决策站不使用 PWA 缓存。该域名历史上可能已注册过 Service Worker，
// 仅“不再注册”不会移除旧 Worker，会导致部署后仍显示旧页面。
if (isDecisionPortal) {
  window.addEventListener('load', async () => {
    try {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      }
      if ('caches' in window) {
        const cacheNames = await window.caches.keys();
        await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
      }
    } catch (error) {
      // 缓存清理失败不应阻止决策站正常使用。
    }
  });
}

// 当新的 Service Worker 接管后，自动刷新到最新包
if (!isDecisionPortal && 'serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    let shouldReload = false;
    try {
      shouldReload = sessionStorage.getItem('sw_update_pending_reload') === '1';
      sessionStorage.removeItem('sw_update_pending_reload');
    } catch (e) {
      // 无 sessionStorage 时：若已有旧控制器被替换，仍刷新一次
      shouldReload = true;
    }
    if (!shouldReload) return;
    refreshing = true;
    window.location.reload();
  });
}
